var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#SVGID_1_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.4671,
    y1: 135.3089,
    x2: 638.0599,
    y2: 735.366
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6083,
    style: {
      stopColor: "#746CFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6329,
    style: {
      stopColor: "#787BF9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7196,
    style: {
      stopColor: "#86AAF3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8024,
    style: {
      stopColor: "#91CFEF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8789,
    style: {
      stopColor: "#99E9EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9471,
    style: {
      stopColor: "#9DF9EA"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9FFFE9"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.3,66.7L666.7,200H533.3V66.7z M466.7,266.7h200V700c0,18.4-14.9,33.3-33.3,33.3H166.7 c-18.4,0-33.3-14.9-33.3-33.3V100c0-18.4,14.9-33.3,33.3-33.3h300V266.7z M233.3,200c0,18.4,14.9,33.3,33.3,33.3h100 c18.4,0,33.3-14.9,33.3-33.3s-14.9-33.3-33.3-33.3h-100C248.3,166.7,233.3,181.6,233.3,200z M566.7,600c0-18.4-14.9-33.3-33.3-33.3 H266.7c-18.4,0-33.3,14.9-33.3,33.3c0,18.4,14.9,33.3,33.3,33.3h266.7C551.7,633.3,566.7,618.4,566.7,600z M266.7,433.3 c-18.4,0-33.3,14.9-33.3,33.3c0,18.4,14.9,33.3,33.3,33.3h266.7c18.4,0,33.3-14.9,33.3-33.3c0-18.4-14.9-33.3-33.3-33.3H266.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.f1475e99a9471644b70af9e216d9eced.svg";
export { ForwardRef as ReactComponent };